import { observable, action, computed } from 'mobx'

// const EN = require('../Localizations/en.json')
const AZ = require('../Localizations/az.json')
const RU = require('../Localizations/ru.json')

export interface ILocalizationEntity {
    [key: string]: object | string,
    lang: string
}

export default class LocalizationStore {

    private static _instance: LocalizationStore

    private constructor() {
        this.setLanguage(window.localStorage.getItem('lang'))
    }

    public static getInstance(): LocalizationStore {
        return this._instance || (this._instance = new this())
    }

    @observable
    lang: string

    @observable
    localizations: ILocalizationEntity

    @action.bound
    private updateLocalizations(data: ILocalizationEntity): void {
        this.localizations = data
    }

    @computed get getLocalizations() {
        return this.localizations
    }

    // availableLanguages = [AZ, RU, EN]
    availableLanguages = [AZ, RU]

    @action.bound
    setLanguage(lang: any) {
        let prevLang = window.localStorage.getItem('lang')

        if (prevLang !== lang) {
            window.localStorage.setItem('lang', lang)
            
            // location.reload()
            // const { history, location } = this.props
            // const current = location.pathname
            // history.push('/reload')
            // setTimeout(() => {
            //     history.replace(current)
            // })
        }
        this.lang = lang ? lang : 'AZ'
        this.updateLocalizations('AZ' === this.lang ? AZ : RU)

    }

    t(key: string): string {
        if (!this) {
            return key
        }

        if (!this.getLocalizations) {
            return key
        }

        return this.getLocalizations[key] ? this.getLocalizations[key].toString() : key
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/LocalizationStore.ts